import React from 'react'
import Image from '../images/gujranwala.jpg'

const Hyderabad = () => {
    return (
        <div className='cities'>
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                    <div className="c_img">
                        <img src={Image} alt="Hyderabad" className='city_img' />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="cities_inner">
                        <h1>Hyderabad</h1>
                        <p>Hyderabad is the capital and largest city of the Indian state of Telangana and the de jure capital of Andhra Pradesh.
                             It occupies 650 km2 (250 sq mi) on the Deccan Plateau along the banks of the Musi River, in the northern part of South India.
                              With an average altitude of 542 m (1,778 ft), much of Hyderabad is situated on hilly terrain around artificial lakes, including
                               the Hussain Sagar lake, predating the city's founding, in the north of the city centre. According to the 2011 Census of India,
                                Hyderabad is the fourth-most populous city in India with a population of 6.9 million residents within the city limits, and has
                                 a population of 9.7 million residents in the metropolitan region, making it the sixth-most populous metropolitan area in India.
                                  With an output of US$74 billion, Hyderabad has the fifth-largest urban economy in India.</p>
                                     </div>
                    </div>
                </div>
            </div>
            
        </div>
    )
}

export default Hyderabad
